<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.items.add_an_item' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">


    <div class="row">
        <div class="col-12">
            <hub-input [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
                [placeholder]="'general.search' | translate" [icon]="'search'" [iconColor]="'#888888'"
                [allowClear]="true" [autofocus]="true"></hub-input>
        </div>
    </div>

    <div class="results-container">
        <div class="header">
            <div>{{filteredResults.length}} {{(filteredResults.length === 1 ? 'bikeshop.workshop.jobcard.quote.result' :
                'bikeshop.workshop.jobcard.quote.results') | translate }}
            </div>
            <div>
                <hub-button [text]="'bikeshop.workshop.jobcard.items.create_new_item' | translate"
                    [style]="'borderless-secondary'" [icon]="'plus'" [size]="'md'" (buttonClick)="createNewItem()">
                </hub-button>
            </div>
        </div>
        <div *ngIf="isloading">
            <app-workshop-jobcard-customer-search-skeleton-loader></app-workshop-jobcard-customer-search-skeleton-loader>
        </div>
        <div class="search-results" *ngIf="filteredResults && filteredResults.length > 0 && !isloading">
            <div *ngFor="let item of filteredResults" class="search-result-item" (click)="!checkIfItemUsed(item) ? selectItem($event, item) : null" [ngClass]="{'used-item': checkIfItemUsed(item)}"    >
                <div>
                    <div *ngIf="item.LastService" class="last-serviced">{{ 'bikeshop.workshop.jobcard.items.last_serviced' | translate }}: {{item.LastService | date : "d MMM yyyy"}}</div>
                    <div class="item-name">{{item.Manufacturer}} {{item.Model}}</div>
                    <div class="item-details">
                        <div *ngIf="item.ModelYear && item.ModelYear > 0">{{item.ModelYear}}</div>
                        <div *ngIf="item.Colour">{{item.Colour}}</div>
                        <div *ngIf="item.BikeSize">{{item.BikeSize}}</div>
                        <div *ngIf="item.SerialNo">{{item.SerialNo}}</div>                        
                    </div>
                </div>
                <div class="action-buttons">
                    <!-- <hub-button [icon]="'plus-alt'"
                        [style]="'secondary'" [size]="'sm'" (buttonClick)="selectedCustomer(customer)">
                    </hub-button> -->
                    <div class="action-button">
                        <hub-button [icon]="'pencil'" [style]="'borderless'" [size]="'sm'"
                            (buttonClick)="editItem($event, item)" [disabled]="checkIfItemUsed(item)"></hub-button>
                    </div>
                </div>
            </div>

        </div>
        <div class="no-results" *ngIf="!isloading && filteredResults.length === 0 && searchTerm.trim() !== ''">
            {{ 'bikeshop.rentals.summary.no_matching_search_results' | translate }}
        </div>
    </div>
</div>


<div class="modal-footer-container">
    <div class="short-cut-container" *ngIf="!searchTerm || searchTerm.trim() === ''">
        <span><daz-icon [name]="'enter'" [size]="'18px'"
                [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.items.create_new_item' |
        translate}}
    </div>
</div>